module.exports = __webpack_public_path__ + "img/poster-2.c2dace84.jpg";